var map = {
	"./area.svg": 613,
	"./arrows-left.svg": 614,
	"./consult.svg": 615,
	"./feedback.svg": 616,
	"./filter-arrow.svg": 617,
	"./gototop.svg": 618,
	"./next.svg": 619,
	"./phone-number.svg": 620,
	"./phone.svg": 621,
	"./prev.svg": 622,
	"./service.svg": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;